import { hasApiErrorCode, unwrapApiError } from '@/utils/apiError'
import { COVERAGE_ERROR_MESSAGES, type CoverageErrorCode } from '@/utils/coverageErrorMessages'

// Catálogo em arquivo próprio (sem imports) para o `getApiErrorMessage` também usá-lo.
export { COVERAGE_ERROR_MESSAGES }
export type { CoverageErrorCode }

const CODES = Object.keys(COVERAGE_ERROR_MESSAGES) as CoverageErrorCode[]

export function getCoverageErrorCode(error: unknown): CoverageErrorCode | null {
  return CODES.find((code) => hasApiErrorCode(error, code)) ?? null
}

export function getCoverageErrorMessage(error: unknown): string | null {
  const code = getCoverageErrorCode(error)
  return code ? COVERAGE_ERROR_MESSAGES[code] : null
}

export const isPlaceholderDoctorBlockedError = (error: unknown): boolean =>
  hasApiErrorCode(error, 'PLACEHOLDER_DOCTOR_BLOCKED')

/**
 * `doctorName` que o BE manda no 422 `PLACEHOLDER_DOCTOR_BLOCKED` (nome do coringa
 * recusado); `null` quando ausente/vazio ou quando o erro é outro.
 */
export function getPlaceholderBlockedDoctorName(error: unknown): string | null {
  if (!isPlaceholderDoctorBlockedError(error)) return null
  const body = (unwrapApiError(error) as { response?: { data?: { doctorName?: unknown } } } | null)
    ?.response?.data
  const name = body?.doctorName
  return typeof name === 'string' && name.trim() ? name : null
}
